// permission.service.ts
import { Injectable } from '@angular/core';
import { TblSubMenu } from '../shared/models/SubMenu';
import { HttpClient } from '@angular/common/http';
import { ExceptionHandler } from '../shared/services/errorhandler';
import { LocalStorageService } from './localStorageService';
import { catchError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonHeader } from '../shared/services/common-header';

@Injectable({ providedIn: 'root' })
export class PermissionService {
    commonHeader: CommonHeader = new CommonHeader()
    private serviceRoot = `${environment.serviceRoot}`;
    private options = this.commonHeader.options;
    constructor(
        private http: HttpClient,
        private ehandler: ExceptionHandler,
        private localStorage: LocalStorageService
    ) { }

    getAllMenus(): Observable<any> {
        return this.http.get(`${this.serviceRoot}/getMenuList`);
    }

    // UPDATE submenu access permission
    updateSubMenuAccess(data: any): Observable<any> {
        return this.http.post(`${this.serviceRoot}/update-access`, data);
    }
    saveSubmenuPermissions(body: TblSubMenu) {
        return this.http.post<any>(
            `${this.serviceRoot}/saveUserAccess`,
            body
        );
    }
    getMenuWithSubmenus() {
        this.localStorage.set("method", "Read")
        this.localStorage.set("operation", "Get All Lead Status")
        const endPoint = `${this.serviceRoot}/getAllLeadStatus`;
        return this.http.get<any[]>(endPoint, this.options)
            .pipe(catchError(this.ehandler.errorHandler));
    }
    private allowedRoutes: string[] = [];

    setPermissions(menuItems: any[]) {
        this.allowedRoutes = menuItems.map(m => m.route);
    }

    hasAccess(route: string): boolean {
        return this.allowedRoutes.includes(route);
    }
}
